import React from 'react';
import Options from '../dashboard/partials/options';
import fakeAuth from '../../../fakeAuth';
import { Link } from 'react-router';
import Gear from '../../partials/gear';
import ScrollAnimation from 'react-animate-on-scroll';
import _ from 'lodash';
import { getBase64, } from '../../../helpers';
import request from 'superagent';
import config from '../../../config';
import Switch from "react-switch";
import { Popover, PopoverBody, PopoverHeader, } from 'reactstrap';

class AddAffiliate extends React.Component {
    state = {
        affiliate: null,
        microTransac: false,
        deleting: false
    }
    componentWillMount() {
        const { affiliates = [], affiliatesActions, params } = this.props, { id } = params;
        if (id) {
            if (affiliates && affiliates.length && _.find(affiliates, a => parseInt(a.id, 10) === parseInt(id, 10))) {
                this.setState({ affiliate: _.find(affiliates, a => parseInt(a.id, 10) === parseInt(id, 10)) })
            } else {
                this.setState({ microTransac: true }, () => {
                    affiliatesActions && affiliatesActions.fetch(id);
                });
            }
        } else {
            this.setState({ affiliate: {} });
        }
    }
    componentWillReceiveProps = nextProps => {
        const { affiliate } = nextProps;
        this.setState({ affiliate, microTransac: false });
    }
    logout = () => {
        fakeAuth.signout(() => {
            this.props.router.push('/admin');
        });
    }
    handleAvatar = e => {
        const { affiliate } = this.state;
        getBase64(e.target.files[0]).then(data => {
            affiliate.Logo = data;
            this.setState({ affiliate });
        });
    }
    save = () => {
        const { affiliate } = this.state, { affiliatesActions } = this.props;
        affiliate.Name = this.txtName.value;
        affiliate.Url = this.txtUrl.value;

        this.setState({ microTransac: true }, () => {
            request[affiliate.id ? 'patch' : 'post'](`${config.apiEndpoint}/api/cs/v2/affiliates${affiliate.id ? `/${affiliate.id}` : ''}`)
                .set('Authorization', `Bearer ${config.apiKey}`)
                .send(affiliate)
                .then((data) => {
                    // TODO: Handle any kind of error here
                    if (data.body.success) {
                        affiliatesActions.fetch();
                        this.props.router.push('/admin/affiliates');
                    } else {
                        alert('ERROR')
                        console.log(data.body);
                        this.setState({ microTransac: false });
                    }
                });
        });
    }
    toggleDelete = () => this.setState({ deleting: !this.state.deleting });
    toggleUseSportslogic = () => {
        const { affiliate } = this.state;
        affiliate.UseSportslogic = !affiliate.UseSportslogic;
        this.setState({ affiliate });
    }
    doDelete = () => {
        const { affiliate } = this.state, { affiliatesActions } = this.props;
        this.setState({ microTransac: true }, () => {

            request.del(`${config.apiEndpoint}/api/cs/v2/affiliates/${affiliate.id}`)
                .set('Authorization', `Bearer ${config.apiKey}`)
                .then((data) => {
                    // TODO: Handle any kind of error here
                    if (data.body.success) {
                        affiliatesActions.fetch();
                        this.props.router.push('/admin/affiliates');
                    } else {
                        alert('ERROR')
                        console.log(data.body);
                        this.setState({ microTransac: false });
                    }
                });
        });
    }
    render() {
        const { affiliate = {}, microTransac } = this.state;
        return (
            <section className="d-flex flex-column h-100">
                <div className="d-flex flex-row p-4">
                    <Link to="/admin/affiliates" className="align-self-center idented d-flex flex-row white font-16">
                        <i className="fas fa-arrow-left margin-right align-self-center" />
                        <span className="anton align-self-center">BACK</span>
                    </Link>
                    {microTransac && <Gear className="ml-auto" />}
                    <h1 className="anton ml-auto align-self-center no-margin no-padding text-right white padding-right">AFFILIATES | ADD</h1>
                </div>
                <div className="h-100" style={{ position: 'relative' }}>
                    <section id="left" style={{ position: "absolute", top: 0, bottom: 0, left: 0, width: 200 }} className="">
                        <Options current={4} onLogout={this.logout} animated={false} />
                    </section>
                    <section id="left" style={{ position: "absolute", overflowY: 'auto', top: 0, bottom: 0, left: 200, right: 0 }} className="clearfix padding-right">
                        {affiliate &&
                            <ScrollAnimation animateIn="fadeInRight" animateOnce={true}>
                                <figure className="card w-100 p-4">
                                    <label htmlFor="name">Affiliate Name</label>
                                    <input className="" type="text" required ref={(i) => this.txtName = i} defaultValue={affiliate.Name} />
                                    <label htmlFor="name" className="margin-top">Affiliate Webpage URL</label>
                                    <input className="" type="text" required ref={(i) => this.txtUrl = i} defaultValue={affiliate.Url} />
                                    <div className="w-100 mt-4">
                                        <label className="d-flex flex-row">
                                            <Switch onChange={this.toggleUseSportslogic} checked={affiliate.UseSportslogic ? true : false} />
                                            <span className="align-self-center margin-left-half">Use Sports Logic</span>
                                        </label>
                                    </div>
                                    <div className="car w-100 p-4 d-flex flex-column justify-content-center pointer">
                                        <input type="file" id="fi" onChange={this.handleAvatar} className="hide" ref={i => this.avatarFU = i} />
                                        <label htmlFor="fi" className="d-flex flex-column justify-content-center h-100">
                                            {!affiliate.Logo && <i className='fas fa-plus font-50 align-self-center green' />}
                                            {affiliate.Logo && <img alt="" style={{ height: 100 }} src={affiliate.Logo} className="align-self-center" />}
                                            <span className="margin-top-half align-self-center black">{affiliate.Logo ? 'Change' : 'Add'}{' '}Logo</span>
                                        </label>
                                    </div>
                                    <div className="d-flex flex-row">
                                        {affiliate.id && <button id="btn-delete" onClick={this.toggleDelete} type="button" style={{ width: 100 }} className="align-self-center btn-red text-center">REMOVE</button>}
                                        <Link to="/admin/affiliates" className="align-self-center btn-link text-center ml-auto margin-right black">CANCEL</Link>
                                        <button onClick={this.save} type="submit" style={{ width: 100 }} className="align-self-center btn-white text-center">SAVE</button>
                                    </div>
                                    {affiliate.id && <Popover placement="bottom" isOpen={this.state.deleting} target={`btn-delete`} toggle={this.toggleDelete}>
                                        <PopoverHeader>Are you sure?</PopoverHeader>
                                        <PopoverBody className="d-flex flex-row justify-content-center">
                                            <button className="btn btn-success btn-sm" onClick={this.doDelete}>Yes, Delete it</button>
                                            <button className="btn btn-danger btn-sm" onClick={this.toggleDelete}>No, Cancel</button>
                                        </PopoverBody>
                                    </Popover>}
                                </figure>
                            </ScrollAnimation>}
                    </section>
                </div>
            </section>
        )
    }
}

export default AddAffiliate;



// WEBPACK FOOTER //
// ./src/components/private/affiliates/add.js